<template>
	<div class="home">
		<button id="backToTop" class="back-to-top" @click="scrollToTop">↑</button>
		<div class="cardp" style="color: #FFFFFF;font-family: 'ago2',sans-serif;">
			<img class="tupian" src="./assets/f1.png" />
			<span class="Title" style="top: 6vw;right:8vw;font-size: 6vw;font-family: 'ago',sans-serif;">MIRACLE WHITE</span>
			<span class="Title" style="top: 15vw;right:8vw;font-size: 2.2vw;">Polypeptide Complex Glutathione 99 MIL</span>
			<span class="Title" style="top: 18vw;right:8vw;font-size: 2vw;">Your Perfect Whitening Skin Starts Here</span>
		</div>
		<div class="cardp">
			<img class="tupian" src="./assets/t1.jpg" />
		</div>
		<!-- <div class="cardme size1" style="font-family: ago3;font-weight: 400;">
			<span>Hess & Co continues to innovate by infusing wisdom with modern science to </span>
			<span>achieve the perfect whitening and anti-aging results.</span>
			<div style="display: flex;flex-direction: column;width: 100%;gap: 1vw;margin-left: 8vw;margin-top: 3vw;">
				<span> Hess & Co continues</span>
				<span style="font-size: 3vw; font-weight: 500;font-family: ago2;">The ultimate ingredients</span>
			</div>
			<div style="display: flex;justify-content: space-evenly;width: 100%;margin-top: 3vw;">
				<div class="card">
					<img  src="./assets/caputer1195.png" />
				  <div class="card__content">
				    <p class="card__title">The combination</p>
				    <p class="card__description">As a result, Hess & Co laboratories witnessed the rise of a revolutionary skin care philosophy, led by Switzerland’s cutting edge thinking.</p>
				  </div>
				</div>
				<div class="card">
					<img  src="./assets/caputer1251.png" />
				  <div class="card__content">
				    <p class="card__title">Improved composition</p>
				    <p class="card__description">Hess & Co deeply believes that beauty does not deteriorate over time, it evolves instead. At every milestone in life, a new irreplaceable radiance is awoken.</p>
				  </div>
				</div>
				<div class="card">
					<img  src="./assets/caputer1256.png" />
				  <div class="card__content">
				    <p class="card__title">MIRACLE WHITE</p>
				    <p class="card__description">Polypeptide Complex Glutathione 99 MIL Your Perfect Whitening Skin Starts Here</p>
				  </div>
				</div>
			</div>
		</div> -->
		<div class="cardp" style="font-family: ago3;">
			<img class="tupian" src="./assets/f2.png" />
			<span class="Title" style="top: 9vw;left:10vw;font-size: 5vw;display: flex;flex-direction: column;font-family: ago2;">
				<span>Improved composition</span>
				<span>with even more</span>
				<span>ingredients</span>
			</span>
			<span class="Title" style="top: 29vw;left:10vw;font-size: 1.4vw;display: flex;flex-direction: column;font-weight: 600;max-width: 50vw;">
				<span>Hess & Co deeply believes that beauty does not deteriorate over time,</span>
				<span>it evolves instead. At every milestone in life, a new irreplaceable radi-</span>
				<span>ance is awoken.</span>
			</span>
		</div>
		<div class="cardp">
			<img class="tupian" src="./assets/f3.jpg" />
		</div>
		<div class="cardp">
			<img class="tupian" src="./assets/f4.png" />
		</div>
		<div class="cardp">
			<img class="tupian" src="./assets/f5.jpg" />
			<span class="Title" style="top: 22vw;left:10vw;font-size: 7vw;display: flex;flex-direction: column;font-family: ago2;">
				<span>The combination</span>
			</span>
			<span class="Title" style="top: 33vw;left:10vw;font-size: 1.4vw;display: flex;flex-direction: column;font-weight: 600;">
				<span>As a result, Hess & Co laboratories witnessed the</span>
				<span>rise of a revolutionary skin care philosophy, led by</span>
				<span>Switzerland’s cutting edge thinking.</span>
			</span>
		</div>
		<div class="cardp">
			<img class="tupian" src="./assets/f6-2.jpg" />
			<!-- <span class="Title" style="top: 22vw;right:8vw;font-size: 7vw;display: flex;flex-direction: column;font-family: ago2;">
				<span>The combination</span>
			</span>
			<span class="Title" style="top: 32vw;right:8vw;font-size: 1.4vw;display: flex;flex-direction: column;font-weight: 600;align-items: flex-end;">
				<span>As a result, Hess & Co laboratories witnessed the</span>
				<span>rise of a revolutionary skin care philosophy, led by</span>
				<span>Switzerland’s cutting edge thinking.</span>
			</span> -->
		</div>
		<div class="cardp">
			<img class="tupian" src="./assets/f72.jpg" />
		</div>
		<div class="cardp">
			<img class="tupian" src="./assets/f8.png" />
			<span class="Title" style="top: 9vw;left:10vw;font-size: 5vw;display: flex;flex-direction: column;font-family: ago2;">
				<span>Improved composition</span>
				<span>with even more</span>
				<span>ingredients</span>
			</span>
			<span class="Title" style="top: 29vw;left:10vw;font-size: 1.3vw;display: flex;flex-direction: column;font-weight: 600;">
				<span>Hess & Co deeply believes that beauty does not deteriorate over time,</span>
				<span>it evolves instead. At every milestone in life, a new irreplaceable radi-</span>
				<span>ance is awoken.</span>
			</span>
		</div>
		<div style="display: flex;justify-content: space-around;width: 100%;padding: 4vw 0;box-sizing: border-box;">
			<img class="mg" width="31%" src="./assets/a1.png"/>
			<img class="mg" width="31%" src="./assets/a2.png"/>
			<img class="mg" width="31%" src="./assets/a3.png"/>
		</div>
		<div style="display: flex;flex-direction: column;width: 100%;box-sizing: border-box;padding: 3vw;font-family: ago4;align-items: center;font-size: 1.4vw;font-weight: 500;">
			<div style="display: flex;flex-direction: column;width:100%;font-family: ago3;font-size: 5vw;align-items: center;padding: 2vw 0;">
				<div>Your beautiful skin</div>
				<div>starts here</div>
			</div>
			<span>Hess & Co deeply believes that beauty does not deteriorate over time, it evolves instead. At every milestone in life, a </span>
			<span style="margin-bottom: 1vw;">new irreplaceable radiance is awoken.</span>
			<span>Hess & Co defies time and reveals healthy and radiant beauty that redefines time and space.</span>
		</div>
		<HR style="FILTER: alpha(opacity=100,finishopacity=0,style=3)" width="80%" color=#987cb9 SIZE=3></HR>
		<div style="display: flex;width: 100%;height: 25vw;align-items: center;justify-content: center;margin: 6vw 0;box-sizing: border-box;">
			
			<div style="display: flex;width: 90%;height: 100%;">
				<div style="display: flex;flex-direction: column;height: 100%;width: 24%;">
					<div style="width: 100%;height: 30%;font-size: 3vw;font-weight: 600;">Wits</div>
					<div style="width: 100%;height: 70%;display: flex;flex-direction: column;font-size: 1.6vw;">
						<div>Wits seamlessly connects</div>
						<div>your SecurityPress</div>
						<div>FAGsAffiliates</div>
					</div>
				</div>
				<div style="display: flex;flex-direction: column;height: 100%;width: 19%;">
					<div style="width: 100%;height: 30%;font-size: 2.5vw;font-weight: 600;">Entity types</div>
					<div style="width: 100%;height: 70%;display: flex;flex-direction: column;font-size: 1.6vw;gap: 15px;">
						<div>Privacy Policy</div>
						<div>Payrool</div>
						<div>Contact</div>
						<div>Support</div>
						<div>Sitemap</div>
					</div>
				</div>
				<div style="display: flex;flex-direction: column;height: 100%;width: 19%;">
					<div style="width: 100%;height: 30%;font-size: 2.5vw;font-weight: 600;">Services</div>
					<div style="width: 100%;height: 70%;display: flex;flex-direction: column;font-size: 1.6vw;gap: 15px;">
						<div>Support Sitemap</div>
						<div>Partners</div>
						<div>Librory Privacy</div>
						<div>Policy</div>
						<div>Cancelation</div>
						<div>Policy</div>
					</div>
				</div>
				<div style="display: flex;flex-direction: column;height: 100%;width: 19%;">
					<div style="width: 100%;height: 30%;font-size: 2.5vw;font-weight: 600;">Sesources</div>
					<div style="width: 100%;height: 70%;display: flex;flex-direction: column;font-size: 1.6vw;gap: 15px;">
						<div>Resources</div>
						<div>Privacy Policy</div>
						<div>Payrool Contact</div>
						<div>Support</div>
						<div>Sitemap</div>
					</div>
				</div>
				<div style="display: flex;flex-direction: column;height: 100%;width: 19%;">
					<div style="width: 100%;height: 30%;font-size: 2.5vw;font-weight: 600;">Support</div>
					<div style="width: 100%;height: 70%;display: flex;flex-direction: column;font-size: 1.6vw;gap: 15px;">
						<div>Privacy Policy</div>
						<div>Payrool</div>
						<div>Contact</div>
						<div>Support</div>
						<div>Sitemap</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import HelloWorld from './components/HelloWorld.vue'
	import '@/assets/text.css';


	export default {
		name: 'app',
		components: {
			HelloWorld
		},
		methods: {
		    scrollToTop() {
		      window.scrollTo({
		        top: 0,
		        behavior: "smooth",
		      });
		    },
		  },
		mounted() {
		    const backToTopButton = document.getElementById("backToTop");
		    const handleScroll = () => {
		      
		        backToTopButton.style.display = "block";
		     
		    };
		    // 初始化时立即检查
		    handleScroll();
		    window.addEventListener("scroll", handleScroll);
		  },
	}
</script>

<style>
.home {
    width: 100vw;
    display: flex;
    flex-direction: column;

    -ms-overflow-style: none;  /* 适用于 Internet Explorer 和 Edge */
    scrollbar-width: none;  /* 适用于 Firefox */
	box-sizing: border-box;
	position: relative;
}




	.cardp {
		width: 100%;
		position: relative;
		box-sizing: border-box;
	}

	.tupian {
		width: 100%;
		display: block;
	}

	.Title {
		position: absolute;
	}
	.cardme{
		
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 3vw 5vw;
		box-sizing: border-box;
	}
	.size1{
		font-size: 1.3vw;
	}
	/* From Uiverse.io by gharsh11032000 */ 
	.card {
	  position: relative;
	  width: 25vw;
	  /* height: 230px; */
	  border-radius: 30px;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  overflow: hidden;
	  perspective: 1000px;
	  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
	  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}
	.card img{
		width: 100%;
		height: 100%;
	}

	
	.card:hover {
	  transform: scale(1.05);
	  box-shadow: 0 8px 16px rgba(255, 255, 255, 0.2);
	}
	
	.card__content {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  padding: 20px;
	  box-sizing: border-box;
	  background-color: rgba(255, 255, 255, 0.8);
	  transform: rotateX(-90deg);
	  transform-origin: bottom;
	  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}
	
	.card:hover .card__content {
	  transform: rotateX(0deg);
	}
	
	.card__title {
	  margin: 0;
	  font-size: 3vw;
	  color: #333;
	  font-weight: 700;
	}
	
	
	
	.card__description {
	  margin: 10px 0 0;
	  font-size: 1vw;
	  color: #777;
	  line-height: 1.4;
	}
	.mg {
	  transition: transform 0.5s ease; /* 过渡效果，0.3秒平滑放大 */
	}
	
	.mg:hover {
	  transform: scale(1.05); /* 鼠标悬停时放大10% */
	}
.back-to-top {
  position: fixed; /* 相对于 .home 容器定位 */
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: none; /* 默认隐藏 */
  justify-content: center;
  align-items: center;
  font-size: 20px;
  transition: opacity 0.3s, transform 0.3s;
  z-index: 1000;
}

.back-to-top:hover {
  background-color: #0056b3;
  transform: scale(1.1);
}

</style>